import React from "react";
import StyledMenu from "../../../../components/layout/StyledMenu";
import { Divider, MenuItem } from "@mui/material";
import { useTranslation } from "react-i18next";

export function FiltersMenu(props) {
  const {
    anchorEl,
    setAnchorEl,
    filterType,
    setFilterType,
    setSoftScoreFilter,
    tableHeadings,
  } = props;

  const { t } = useTranslation("translation", {
    keyPrefix: "components.EventSoftScores"
  });

  const open = Boolean(anchorEl);

  return (
    <>
      <StyledMenu
        id="filters-menu"
        MenuListProps={{
          "aria-labelledby": "filters-button",
        }}
        disableScrollLock
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem
          selected={filterType === "" ? true : false}
          onClick={async (e) => {
            setSoftScoreFilter(null);
            setFilterType("");
            setAnchorEl(null);
          }}
          disableRipple
        >
          {t("allSoftScores")}
        </MenuItem>

        {tableHeadings && (
          <Divider
            sx={{
              mt: 2,
              mb: 2,
            }}
          />
        )}

        {tableHeadings &&
          tableHeadings.map((row, index) => (
            <MenuItem
              selected={filterType === row ? true : false}
              onClick={async (e) => {
                setSoftScoreFilter(row);
                setFilterType(row);
                setAnchorEl(null);
              }}
              disableRipple
              key={index}
            >
              {row}
            </MenuItem>
          ))}
      </StyledMenu>
    </>
  );
}

export function SortMenu(props) {
  const { anchorEl, setAnchorEl, sortType, setSortType } = props;

  const { t } = useTranslation("translation", {
    keyPrefix: "components.EventSoftScores"
  });

  const open = Boolean(anchorEl);

  return (
    <>
      <StyledMenu
        id="filters-menu"
        MenuListProps={{
          "aria-labelledby": "filters-button",
        }}
        disableScrollLock
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem
          selected={!sortType}
          onClick={async (e) => {
            setSortType(null);
            setAnchorEl(null);
          }}
          disableRipple
        >
          {t("sortAtoZ")}
        </MenuItem>

        <MenuItem
          selected={sortType === "z-a" ? true : false}
          onClick={async (e) => {
            setSortType("z-a");
            setAnchorEl(null);
          }}
          disableRipple
        >
          {t("sortZtoA")}
        </MenuItem>

        <MenuItem
          selected={sortType === "desc" ? true : false}
          onClick={async (e) => {
            setSortType("desc");
            setAnchorEl(null);
          }}
          disableRipple
        >
          {t("sortDescending")}
        </MenuItem>
        <MenuItem
          selected={sortType === "asc" ? true : false}
          onClick={async (e) => {
            setSortType("asc");
            setAnchorEl(null);
          }}
          disableRipple
        >
          {t("sortAscending")}
        </MenuItem>
      </StyledMenu>
    </>
  );
}
